import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["shortlistItemFilled", "shortlistItemEmpty"];

  connect() {
    this.setShortlist(this.getLocalStorageData());
    this.addEventListeners();
  }

  getLocalStorageData() {
    const storedShortlistData = localStorage.getItem("shortlistData");
    if (storedShortlistData) {
      return JSON.parse(storedShortlistData);
    }
    return [];
  }

  removeFromLocalStorage(id) {
    const storedShortlistData = localStorage.getItem("shortlistData");
    if (storedShortlistData) {
      const shortlistData = JSON.parse(storedShortlistData);
      const updatedShortlistData = shortlistData.filter((item) => item.id !== id);
      localStorage.setItem("shortlistData", JSON.stringify(updatedShortlistData));
    }

    this.setShortlist(this.getLocalStorageData());
    document.dispatchEvent(new CustomEvent("updateShortlist"));
  }

  setShortlist(selectedVenues) {
    const venueCount = selectedVenues.length;

    this.shortlistItemFilledTargets.forEach((element, index) => {
      element.classList.toggle("hidden", index >= venueCount);
    });

    this.shortlistItemEmptyTargets.forEach((element, index) => {
      element.classList.toggle("hidden", index < venueCount);
    });

    selectedVenues.forEach((venueData, index) => {
      this.addVenue(venueData, index);
    });
  }

  addEventListeners() {
    document.addEventListener("updateShortlist", () => {
      this.setShortlist(this.getLocalStorageData());
    });
  }

  addVenue(venueData, index) {
    const shortlistItem = this.shortlistItemFilledTargets[index];

    shortlistItem.querySelector("img").src = venueData.image;
    shortlistItem.querySelector(".venue-name").textContent = venueData.name;
    shortlistItem.querySelector(".venue-suburb").textContent = venueData.suburb;
    if (shortlistItem.querySelector(".venue-delete-button")) {
      shortlistItem.querySelector(".venue-delete-button").id = venueData.id;
    }
  }

  removeItem(event) {
    const removeItemId = event.currentTarget.id;
    this.removeFromLocalStorage(removeItemId);
  }
}
